export default __webpack_public_path__ + "static/hepatitis-b-63614b4374e26f8f0b24b3cc8a5a233c.png";